<template>
  <div class="grid gap-8">
    <div v-for="meal, key in meals" :key="meal.id">
      <BlocksRestaurantOffersStandardCard :position="key+1" :date="date" :meal="meal" :restaurant="meal.restaurant" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  meals: Object,
  date: String,
})
</script>

<style lang="scss" scoped>
// 
</style>